
import React, { Component } from 'react';

var dateUtil = require('../../utils/dateUtil/dateUtil');

class LongPressComponent extends Component 
{
    constructor(props) 
    {
        super(props);

        this.onClickCapture = this.onClickCapture.bind(this);
        this.onMouseDownCapture = this.onMouseDownCapture.bind(this);
        this.onMouseUpCapture = this.onMouseUpCapture.bind(this);
        this.onTouchStartCapture = this.onTouchStartCapture.bind(this);
        this.onTouchEndCapture = this.onTouchEndCapture.bind(this);
        this.onContextMenu = this.onContextMenu.bind(this);

        this.state = {};
        this.state.startedAt = null;
        this.state.endedAt = null;
    }

    render()
    {
        return <span  onClickCapture={this.onClickCapture}
                      onMouseDownCapture={this.onMouseDownCapture}
                      onMouseUpCapture={this.onMouseUpCapture}
                      onTouchStartCapture={this.onTouchStartCapture}
                      onTouchEndCapture={this.onTouchEndCapture}
                      onContextMenu={this.onContextMenu} 
                      {...this.props}>
                    {this.props.children}
               </span>
    }

    onClickCapture(e)
    {
        e.stopPropagation();
        if (this.props.disabled)
            return;

        if (this.state.startedAt == null || this.state.endedAt == null ||
            dateUtil.differenceInMilliseconds(this.state.endedAt, this.state.startedAt) <= 400
            )
        {
            this.props.onClick();
            return;
        }

        this.props.onLongPress();
    }

    onMouseDownCapture(e)
    {
        e.stopPropagation();
        if (this.props.disabled)
            return;

        this.state.startedAt = dateUtil.getNow();
        this.state.endedAt = null;
    }

    onMouseUpCapture(e)
    {
        e.stopPropagation();
        if (this.props.disabled)
            return;

        this.state.endedAt = dateUtil.getNow();
    }

    onTouchStartCapture(e)
    {
        e.stopPropagation();
        if (this.props.disabled)
            return;

        this.state.startedAt = dateUtil.getNow();
        this.state.endedAt = null;
    }

    onTouchEndCapture(e)
    {
        e.stopPropagation();
        if (this.props.disabled)
            return;
            
        this.state.endedAt = dateUtil.getNow();
    }

    onContextMenu(e)
    {
        e.preventDefault();
        this.props.onLongPress();
    }
}

export default LongPressComponent;